(function ($, document, window) {
    'use strict';

    $(function () {
        const $carousel = $('.js-story-carousel');

        $carousel.each(function () {
            const $this = $(this);
            const $container = $this.closest('.js-featured-stories-container');
            const pagination = $container.find('.js-story-carousel-pagination').toArray();
            const prevEl = $container.find('.js-story-carousel-nav-prev').toArray();
            const nextEl = $container.find('.js-story-carousel-nav-next').toArray();

            const swiper = new Swiper(this, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 24,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                mobileFirst: true,
                grabCursor: true,
                speed: 800,

                pagination: {
                    el: pagination,
                    type: 'progressbar',
                },

                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },

                breakpoints: {
                    768: {
                        spaceBetween: 24,
                    },

                    1024: {
                        spaceBetween: 30,
                        slidesOffsetBefore: 30,
                        slidesOffsetAfter: 30,
                    },

                    1400: {
                        spaceBetween: 30,
                        slidesOffsetBefore: 60,
                        slidesOffsetAfter: 60,
                    },

                    1520: {
                        spaceBetween: 30,
                        slidesOffsetBefore: function () {
                            return ($(window).outerWidth() - $container.width()) / 2;
                        },
                        slidesOffsetAfter: function () {
                            return ($(window).outerWidth() - $container.width()) / 2;
                        },
                    },
                },
            })
        });
    });
})(jQuery, document, window);
